const ActionButtons = ({links}) => {
    if (!links || links.length === 0) return null;
    
    return (
        <div className="w-[100%] justify-center md:justify-start items-center gap-2 lg:gap-5 flex flex-col sm:flex-row">
               {links.map((link, k) => 
                 <div className="w-[95%] sm:w-[168px] h-[35px] rounded justify-start items-center flex mb-[20px]" key={k}>
                    <a href={link.link} className={`w-[100%] px-5 py-2.5 rounded-[50px] justify-center items-center gap-2.5 flex ${link.type==2? "bg-[#C0834D]" : "bg-gradient-to-r from-[#6082a0] to-[#e55961]"} overflow-hidden text-white text-base font-bold font-['Open Sans']`} target="_blank">
                        {link.caption? link.caption : "Заказчик о нас"}
                    </a>
                </div>)}
        </div>
    )
}

export default ActionButtons;